import { DialogContent, DialogRoot } from '@/components/ui/Dialog'
import type { ProjectVideo } from '../model'
import { VideoImporter } from './VideoImporter'

export interface AddVideoDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Videos already in the project — the picker marks them as taken. */
  usedTempPaths: string[]
  onVideo: (video: ProjectVideo) => void
}

/** "Adicionar vídeo" — the same importer, pointed at an open project. */
export function AddVideoDialog({ open, onOpenChange, usedTempPaths, onVideo }: AddVideoDialogProps) {
  return (
    <DialogRoot open={open} onOpenChange={onOpenChange}>
      <DialogContent
        title="Adicionar vídeo ao projeto"
        description="Envie um arquivo, baixe do YouTube ou reaproveite algo que já está no servidor."
      >
        <VideoImporter
          showExisting
          usedTempPaths={usedTempPaths}
          onVideo={(video) => {
            onVideo(video)
            onOpenChange(false)
          }}
        />
      </DialogContent>
    </DialogRoot>
  )
}
